import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useUnsavedChangesGuard } from './useUnsavedChangesGuard'

type LeaveTarget = { path: string; replace?: boolean }

/**
 * The unsaved changes guard of an edit page, active while `when` is true, plus `leave` for navigating
 * after a save or delete without being asked: the guard is switched off first and the page navigates
 * once it is.
 */
export const useEditPageLeave = (when: boolean) => {
  const navigate = useNavigate()
  const [leaveTo, setLeaveTo] = useState<LeaveTarget>()
  const guard = useUnsavedChangesGuard(when && !leaveTo)

  useEffect(() => {
    if (!leaveTo) return
    navigate(leaveTo.path, { replace: leaveTo.replace })
    setLeaveTo(undefined)
  }, [leaveTo, navigate])

  const leave = useCallback((path: string, options?: { replace?: boolean }) => setLeaveTo({ path, replace: options?.replace }), [])

  return { guard, leave, isLeaving: !!leaveTo }
}
